import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { tables } from "@botpress/client";
import { useSnackbar } from "notistack";

import * as BotpressSessionActions from "../../state/redux/botpressSession";
import BotpressConversationDialog from "../dialogs/botpressConversationDialog.js";
import BotpressFeedbackDialog from "../dialogs/botpressUserFeedbackDialog.js";
import BotpressFeedbackTable from "../ui/botpressFeedbackTable.js";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget.js";
import WidgetSkeleton from "../ui/widgetSkeleton.js";
import WidgetSurveyContent from "../ui/widgetSurveyContent.js";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressUserFeedback = props => {
  const {
    feedback,
    searchFeedbackRequest,
    deleteChatRequest,
    feedbackPagination,
    loadConversationRequest,
    widgetSize = "full",
    minHeight = "333px",
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [rows, setRows] = useState(null);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);

  useEffect(() => {
    if (feedback != null) {
      setRows(feedback);
    } else {
      setRows([]);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedback]);

  const onRequestNewPage = async pagination => {
    try {
      searchFeedbackRequest(pagination);
    } catch (error) {
      console.error("Error getting table rows", error);
      setRows([]);
    }
  };

  useEffect(() => {
    if (selectedConversation != null) {
      loadConversationRequest(selectedConversation.conversationId);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConversation]);

  return (
    <Widget widgetSize={widgetSize} minHeight={minHeight}>
      <WidgetTitle title={"Feedback"} text={"User Comments"}>
        <OmniResponsiveButton
          tooltipTitle="Load this table again"
          buttonText="Refresh"
          onClick={() => {
            onRequestNewPage(feedbackPagination);
          }}
        />
      </WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <BotpressFeedbackTable
            data={rows}
            onEditEntry={setSelectedEntry}
            onRequestNewPage={onRequestNewPage}
            dataReduxPagination={feedbackPagination}
            onViewConversation={setSelectedConversation}
          />
        </WidgetSurveyContent>
      )}

      {selectedEntry != null && (
        <BotpressFeedbackDialog
          open={selectedEntry != null}
          userFeedbackRecord={selectedEntry}
          onAccept={theRecord => {
            props.updateFeedbackRequest({ feedbackRecord: theRecord });
            setSelectedEntry(null);
          }}
          onDelete={theRecord => {
            props.deleteFeedbackRequest({ feedbackId: theRecord.id });
            setSelectedEntry(null);
          }}
          onClose={() => {
            setSelectedEntry(null);
          }}
        />
      )}

      {selectedConversation != null && (
        <BotpressConversationDialog
          conversationId={selectedConversation.conversationId}
          conversation={props.conversation}
          conversationFeedback={props.conversationFeedback}
          deleteFeedbackRequest={props.deleteFeedbackRequest}
          updateFeedbackRequest={props.updateFeedbackRequest}
          userODM={props.userODM}
          open={selectedConversation != null}
          defaultValue={selectedConversation}
          onAccept={() => {
            setSelectedConversation(null);
          }}
          onClose={() => {
            setSelectedConversation(null);
          }}
          onDelete={() => {
            deleteChatRequest({ conversationId: selectedConversation.id });
            setSelectedConversation(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  feedback: state.botpressSession.feedback,
  feedbacksStartDate: state.botpressSession.feedbacksStartDate,
  feedbacksEndDate: state.botpressSession.feedbacksEndDate,
  feedbackPagination: state.botpressSession.feedbackPagination,

  conversation: state.botpressSession.conversation,
  conversationFeedback: state.botpressSession.conversationFeedback,

  userODM: state.userSession.userODM,

  botODM: state.botpressSession.botpressBotODM,
});

const mapDispatchToProps = {
  searchFeedbackRequest: BotpressSessionActions.searchFeedbackRequest,
  deleteChatRequest: BotpressSessionActions.deleteChatRequest,
  loadConversationRequest: BotpressSessionActions.loadConversationRequest,
  deleteFeedbackRequest: BotpressSessionActions.deleteFeedbackRequest,
  updateFeedbackRequest: BotpressSessionActions.updateFeedbackRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressUserFeedback);
